// extracted by mini-css-extract-plugin
module.exports = {"head":"Header_head__zcklB"};